import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import PredefinedPhrasesSetup from './PredefinedPhrasesSetup';

loadDOMComponent({
	selector: 'react-predefined-phrases',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<PredefinedPhrasesSetup />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
